import {
    PointGeometry,
    pointGeometrySchema,
} from 'app/agriculture/queries/types/geometry/PointGeometry';
import { z } from 'zod';

export const farmSchema = z.object({
    address: z.string().optional(),
    agSetupComplete: z.boolean(),
    center: pointGeometrySchema,
    id: z.number(),
    name: z.string(),
    timeZone: z.string(),
    viewAngle: z.number(),
    viewHeight: z.number(),
    viewRotation: z.number(),
    weatherStation: z.string().uuid().nullable(),
    imageSrc: z.string().optional(),
});

export interface Farm {
    address?: string;
    agSetupComplete: boolean;
    center: PointGeometry;
    id: number;
    name: string;
    timeZone: string;
    viewAngle: number;
    viewHeight: number;
    viewRotation: number;
    weatherStation: string | null;
    imageSrc?: string;
}
